import axios from 'axios'
import qs from 'qs'

import router from '@/router'
import useAppStore from '@/stores/app'

const api = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL,
  paramsSerializer: (params) =>
    qs.stringify(params, {
      arrayFormat: 'repeat',
      encodeValuesOnly: true,
    }),
})

api.interceptors.request.use((request) => {
  const appStore = useAppStore()
  if (!appStore.signedIn) {
    return request
  }

  request.headers['Authorization'] = `Bearer ${appStore.auth.tokens.access}`
  return request
})

api.interceptors.response.use(
  async (response) => response.data,

  async (error) => {
    const request = error.config
    const appStore = useAppStore()
    if (
      error.response.status !== 401 ||
      error.response.data.detail !== 'Token expired' ||
      !appStore.signedIn
    ) {
      throw error.response?.data.detail || error
    }

    try {
      await appStore.refreshTokens()
      request.headers['Authorization'] = `Bearer ${appStore.auth.tokens.access}`
      return api(request)
    } catch (error) {
      await router.push({ name: 'sign-in' })
      appStore.signOut()
    }
  },
)

export default api
